<template>
  <div>
    <core-section id="skills">

        <v-col cols="12">
            <v-row justify="space-between">
                <core-heading cols="auto">
                    {{ $t('skills.title') }}
                </core-heading>
            </v-row>
        </v-col>

        <v-col cols="12">
            <v-row justify="space-around">
                <!-- skills -->
                <v-col cols="12" md="3" tag="section">
                    <Skill v-for="(skill, index) in items.skills" :key="index" :value="skill" />
                </v-col>

                <!-- universities -->
                <v-col cols="12" md="4" tag="section">
                    <h3 class="text-h5 font-weight-medium mb-4 primary--text">
                        {{ $t('skills.universities-title') }}
                    </h3>

                    <EducationCard
                        v-for="(degree, index) in items.universities"
                        :key="index"
                        :value="degree"
                    />

                    <!-- language -->
                    <h3 class="text-h5 font-weight-medium mb-4 primary--text">
                        {{ $t('skills.language-title') }}
                    </h3>

                    <EducationCard
                        v-for="(degree, index) in items.language"
                        :key="'A' + index"
                        :value="degree"
                    />

                    <!-- interests -->
                    <h3 class="text-h5 font-weight-medium mb-4 primary--text">
                        {{ $t('skills.interests-title') }}
                    </h3>

                    <education-card
                        v-for="(degree, index) in items.interests"
                        :key="'B' + index"
                        :value="degree"
                    />
                </v-col>

                <!-- courses -->
                <v-col cols="12" md="4" tag="section">
                    <h3 class="text-h5 font-weight-medium mb-4 primary--text">
                        {{ $t('skills.courses-title') }}
                    </h3>
                    <education-card v-for="(degree, i) in items.courses" :key="i" :value="degree" />
                </v-col>
            </v-row>
        </v-col>

        <v-card class="mx-auto " color="secondary">
            <v-card-text>
                <v-col cols="auto">
                    <v-btn v-if="($i18n.locale === 'pl')" x-large color="primary" @click="downloadPDf('Adam_Jankowski_CV_PL.pdf')">
                      <v-icon class="ma-0">mdi-download-circle-outline</v-icon>{{ $t('skills.download-btn') }}
                    </v-btn>
                  <v-btn v-else x-large color="primary" @click="downloadPDf('Adam_Jankowski_CV_EN.pdf')">
                    <v-icon class="ma-0">mdi-download-circle-outline</v-icon>{{ $t('skills.download-btn') }}
                  </v-btn>
                </v-col>
            </v-card-text>
        </v-card>
    </core-section>

    <v-row justify="space-around">
      <v-col cols="auto">
        <v-dialog
            transition="dialog-bottom-transition"
            max-width="600"
            v-model="dialog">
          <template>
            <v-card>
              <v-toolbar color="primary" dark>
                <v-toolbar-title><v-icon class="pa-1">mdi-information-outline </v-icon>{{ $t('skills.message-info') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <div class="text-h6 pa-10">{{ $t('skills.message-info-text') }}</div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                    class="ma-0"
                    color="primary"
                    @click="dialog = false"
                >{{ $t('skills.btn-close') }}<v-icon class="ma-0">mdi-close</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>

  </div>
</template>

<script>
export default {
    name: 'Skills',

  data: () => ({
    dialog: false,
  }),

    components: {
        EducationCard: () => import('@/components/EducationCard'),
        Skill: () => import('@/components/Skill'),
    },

    computed: {
        items() {
            return this.$i18n.t('skills');
        },
    },

    methods: {
        forceFileDownload(response, fileName) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        },

        downloadPDf(fileName) {
            this.axios({
                method: 'get',
                url: 'static/' + fileName,
                responseType: 'arraybuffer',
            })
                .then(response => {
                    this.forceFileDownload(response, fileName);
                    this.dialog = true;
                })
                .catch(() => console.log('Error - no file!'));
        },
    },
};
</script>
